import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

import StringInput from '../StringInput';

export const AutoCompleteContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	${(props) => props.viewmode && `overflow: auto;`};
`;

export const AutoCompleteInputWrapper = styled.div`
	display: flex;
	position: relative;
`;

export const AutoCompleteInputContainer = styled.div`
	display: flex;
	position: relative;
	width: 100%;
	align-items: center;
`;

export const AutoCompleteInput = styled(StringInput, {
	shouldForwardProp: (prop) => isPropValid(prop)
})`
	padding: var(--inputPadding) ${(props) => (props.isSelected ? '3rem' : 'var(--inputPadding)')} var(--inputPadding)
		${(props) => (props.isSelected ? 'var(--inputPadding)' : '3.5rem')};

	body[dir='rtl'] & {
		padding: var(--inputPadding) ${(props) => (props.isSelected ? 'var(--inputPadding)' : '3.5rem')}
			var(--inputPadding) ${(props) => (props.isSelected ? '3rem' : 'var(--inputPadding)')};
	}
`;

export const DeleteIconContainer = styled.div`
	display: flex;
	align-items: center;
	color: var(--black);

	> .icon {
		position: absolute;
		right: 1rem;

		:hover,
		:focus {
			cursor: pointer;
		}

		body[dir='rtl'] & {
			right: unset;
			left: 1rem;
		}
	}
`;

export const AutoCompleteContentWrapper = styled.div`
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-10);
	overflow: auto;
	box-shadow: var(--container-box-shadow);
	padding: var(--padding-2);
	max-width: 100vw;
	overflow: auto;
`;

export const AutoCompleteItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	justify-content: space-between;
	border-radius: var(--small-border-radius);
	border-inline-start: 2px solid transparent;

	:hover,
	:focus,
	:active {
		background-color: var(--table-selected-color);
	}

	&.focus {
		background-color: var(--actionButtonColor);
	}

	&.disabled {
		background-color: unset !important;
		opacity: 0.5;
		cursor: not-allowed;
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const CheckboxCell = styled.div`
	padding: var(--padding-2) 0 var(--padding-2) var(--padding-2);

	> input {
		cursor: pointer;
		vertical-align: middle;
	}

	body[dir='rtl'] & {
		padding: var(--padding-2) var(--padding-2) var(--padding-2) 0;
	}
`;

export const Cell = styled.div`
	flex: ${({ width }) => width ?? 200} 1 auto;
	width: ${({ width }) => width ?? 200}px;
	padding: var(--padding-2);
	overflow: hidden;
	display: flex;
	align-items: center;
`;

export const AutoCompleteNoItems = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 3rem;
`;

export const Loading = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
`;

export const Wrapper = styled.ul`
	display: flex;
	flex-wrap: wrap;
	overflow: auto;
	list-style: none;
	cursor: text;
	clear: left;
	margin: 0;
	padding: 0 0 0 ${(props) => (props.isSelected ? '0' : '2.3rem')};
	background-color: var(--input-bg-color);
	width: 100%;
	max-height: 20rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	:hover,
	:active {
		background-color: var(--table-selected-color);
	}
	:focus-within {
		border: 1px solid var(--blue);
		background-color: var(--table-selected-color);
	}
	&.error {
		border: 1px solid var(--red) !important;
		background-color: var(--red-10);
	}
	&.disabled {
		border: 1px solid var(--border-color);
		background-color: var(--input-disabled-bg-color);
		color: var(--content-4);

		&.error {
			border: 1px solid var(--red);
		}
	}

	body[dir='rtl'] & {
		padding: 0 ${(props) => (props.isSelected ? '0' : '2.3rem')} 0 0;
	}
`;

export const Token = styled.li`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 auto;
	margin: 0.3rem var(--margin-1);
	padding: 0.25rem var(--padding-1) 0.25rem var(--padding-3);
	border-radius: 400px;
	border: 1px solid var(--blue-70);
	background-color: var(--blue-10);
	color: var(--black);
	cursor: default;
	overflow: hidden;
	max-width: 12rem;

	> svg {
		padding: var(--padding-1);
		margin-left: var(--margin-1);
		border-radius: 50%;
		width: 1.2rem;
		height: 1.2rem;
		cursor: pointer;

		:hover {
			background-color: var(--table-selected-color);
		}

		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: var(--margin-1);
		}
	}

	body[dir='rtl'] & {
		padding: 0.25rem var(--padding-3) 0.25rem var(--padding-1);
	}
`;

export const InputToken = styled.li`
	display: inline-flex;
	align-items: center;
	flex: 1 1 auto;
	margin: 0;
	color: var(--black);
	cursor: text;
	overflow: hidden;
`;

export const Input = styled(StringInput)`
	border: 0 none !important;
	outline: 0 none !important;
	background-color: transparent !important;
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 1rem;
	color: var(--black);
	z-index: 1;

	body[dir='rtl'] & {
		left: unset;
		right: 1rem;
	}
`;
